import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";
import { Toaster } from "@/components/ui/sonner";
import "@/i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <Toaster richColors position="top-right" />
  </React.StrictMode>,
);

// PWA service worker registration — only when the browser supports it AND
// we're served over https/localhost. The SW is a no-op for cross-origin API
// calls; it only handles app-shell + allowlisted GETs.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then(() => {
        // SW registered — no UX surface needed yet.
      })
      .catch(() => {
        // Registration failed (e.g. dev mode without https) — silent fallback.
      });
  });
}
